export default __webpack_public_path__ + "static/media/header-arrow-up.37084a2b.svg";